// extracted by mini-css-extract-plugin
module.exports = {"page":"_5DzEU2YF","network":"_5D2vjyTO","mask":"_5D6UBA93"};